import { http } from '@/http'

const buildFormData = (data, file) => {
  const fd = new FormData()
  Object.entries(data).forEach(([k, v]) => {
    if (v != null) fd.append(k, v)
  })
  if (file) fd.append('file', file)
  return fd
}

export default {
  create(data, file) {
    return http.post('/payroll-movements', buildFormData(data, file), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  createBulk(data)            { return http.post('/payroll-movements/bulk', data) },
  update(id, data)            { return http.put(`/payroll-movements/${id}`, data) },
  cancel(id)                  { return http.put(`/payroll-movements/${id}/cancel`) },
  get(id)                     { return http.get(`/payroll-movements/${id}`) },
  getByPeriod(data)           { return http.post('/payroll-movements/list', data) },
  getByEmployee(employeeId)   { return http.get(`/payroll-movements/employee/${employeeId}`) },
  getSummary(data)            { return http.post('/payroll-movements/summary', data) },
  downloadListXlsx(data)      { return http.post('/payroll-movements/list/xlsx', data, { responseType: 'blob' }) },
  downloadSummaryXlsx(data)   { return http.post('/payroll-movements/summary/xlsx', data, { responseType: 'blob' }) },
  getInstallmentGroup(groupId)      { return http.get(`/payroll-movements/group/${groupId}`) },
  cancelFutureInstallments(groupId) { return http.put(`/payroll-movements/group/${groupId}/cancel`) },
  getInstallmentGroups(data)        { return http.post('/payroll-movements/groups', data) },
  downloadAttachment(id)            { return http.get(`/payroll-movements/${id}/attachment`, { responseType: 'blob' }) },
}
